import { getSingleFileReturnStatus, getSingleFile } from '../../helpers/axiosWrapper';

export const downloadBackingDataReport = async (
  url: string | undefined,
  context: any,
  requestId: string
): Promise<any> => {
  const headers: any = {
    downloadFormat: 'xlsx',
  };
  return await getSingleFile(url + `/ersgatewayadapter/invoice-download-report/${requestId}`, { headers }, context);
};

export const downloadPdfReport = async (url: string | undefined, context: any, requestId: string): Promise<any> => {
  const headers: any = {
    downloadFormat: 'ZIP',
  };
  return await getSingleFile(url + `/ersgatewayadapter/invoice-download-report/${requestId}`, { headers }, context);
};

export const downloadSubmitMeterReadTemplate = async (
  url: string | undefined,
  context: any,
  customerAccountReference: string
): Promise<any> => {
  const query = `CustomerAccountReference=${customerAccountReference}`;

  return await getSingleFileReturnStatus(
    url + `/ersgatewayadapter/meter/generate-meter-read-template?${query}`,
    {},
    context
  );
};
